import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { DTO } from './base.dto';
import { ResponseType } from 'axios';

export class AddMortgageDealFavoriteBody {
	public mortgageApplicationId!: string;
	public isAdd!: boolean;
}

export class AddMortgageDealFavoriteDTO extends DTO {
	public query: undefined;
	public param: undefined;
	public url: string = ENDPOINT.ADD_MORTGAGE_DEAL_FAVORITE;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(public body: AddMortgageDealFavoriteBody) {
		super();
		this.body = body;
	}
}
